import React from "react";
import { useNavigation } from "@react-navigation/native";
import { useTranslations } from "@src/packages/i18n";
import { useSubmitSubstances } from "../useSubmitSubstances";
import type { SubstancesStackScreenProps } from "../SubstancesNavigator";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";

export function SubstancesCompleteScreen() {
  const t = useTranslations();
  const navigation =
    useNavigation<
      SubstancesStackScreenProps<"SubstancesComplete">["navigation"]
    >();
  const { submit, isPending } = useSubmitSubstances();

  const handleFinish = async () => {
    try {
      await submit();
      navigateToNextSection(navigation, "substances");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      title={t("med_history.lifestyle.substances.complete_title")}
      subtitle={t("med_history.lifestyle.substances.complete_subtitle")}
      secondarySubtitle={null}
      buttonLabel={getNextSectionButtonLabel(t, "substances")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}
